import React, { useEffect } from 'react'
import { useRequestForgetPasswordOtp, useVerifyForgetPasswordOtp } from '../../../core/services/react-query/useAuthQuery'
import { Text } from '../../../modules/Dashboard'
import { Navigate, useNavigate } from 'react-router-dom'
import OTPInput from '../../../components/common/OtpInput'
import SetPasswordForm from '../components/SetPasswordForm'
import { Label } from '../../../styles/newStyles/Register.styled'

const ForgetPassword = ({
    inputValues,
    otpInputRef,
    verifyCode,
    onVerifyCodeChange,
    timer,
    onOtpResend,
    verifyData,
    authCode,
    setAuthCode,
    password,
    setPassword,
    setValidationStatus,
}) => {

    const navigate = useNavigate()

    useEffect(() => {
        if (!inputValues.mobileOrEmail) {
            navigate('/auth/signin')
        }

    }, [inputValues])

    return (
        <div className='flex flex-col gap-8'>
            <div className='space-y-2 w-full'>
                <OTPInput
                    singleField
                    timer={timer}
                    onOtpResend={onOtpResend}
                    ref={otpInputRef}
                    value={verifyCode}
                    autoFocus={true}
                    onOtpChange={onVerifyCodeChange}
                />
                <Label className='!flex-col items-start'>
                    <Text tid={'code-sent_part-1'} className='text-secondaryColor' />
                    <span className='text-base text-secondaryColor font-semibold'>{inputValues.mobileOrEmail}</span>
                </Label>
            </div>
            <SetPasswordForm
                setValidationStatus={setValidationStatus}
                password={password}
                onPasswordChange={setPassword}
            />
        </div>
    )
}

export default ForgetPassword